import { sendCustomError } from '@otto-ec/global-resources/apm'
import { isEmpty } from '../utils/is-empty'
import {
  LoggingServicePort,
  LogLabelsParam,
  LogMessageParam,
} from '../../ports'

export class LoggingServiceApmAdapter implements LoggingServicePort {
  constructor(private readonly random: () => number = Math.random) {}

  static readonly NAMESPACE = 'eprivacy_consentBanner'

  logMessageWithId(
    id: `${Uppercase<string>}.${string}`,
    message: LogMessageParam,
    labels?: LogLabelsParam
  ): void {
    this.logMessages(id, message, labels)
  }

  logMessage(message: LogMessageParam, labels?: LogLabelsParam): void {
    this.logMessages(undefined, message, labels)
  }

  logError(error: unknown, labels?: LogLabelsParam): void {
    if (error instanceof Error || typeof error === 'string') {
      this.logMessage(error, labels)
      return
    }
    try {
      this.logMessage(JSON.stringify(error), labels)
    } catch (e: unknown) {
      /*                                             */
      this.logError(e, labels)
    }
  }

  sample(
    sampleRate: number,
    message: LogMessageParam,
    labels?: LogLabelsParam
  ): void {
    if (this.random() < sampleRate) {
      this.logMessage(message, { ...(labels ?? {}), sampleRate })
    }
  }

  private logMessages(
    id: string | undefined,
    message: LogMessageParam,
    labels?: LogLabelsParam
  ): void {
    if (isEmpty(message) && isEmpty(labels)) {
      return
    }

    void sendCustomError(
      isEmpty(id)
        ? LoggingServiceApmAdapter.NAMESPACE
        : [LoggingServiceApmAdapter.NAMESPACE, id].join('.'),
      message,
      labels
    )
  }
}
